<script>
import DefaultFiltersComponent from '@/components/DefaultFiltersComponent.vue'
import { mapActions } from "vuex";
import XLSX from 'xlsx/xlsx';
import {currency, formatDateValue} from "./../../../helpers/filter";

export default {
  name: 'ItemsFiltersComponent',
  extends: DefaultFiltersComponent,
  data() {
    return {
      path: 'items',      
    }
  },
  methods: {
    ...mapActions({
      setDataToList(dispatch, payload) {
        return dispatch(this.getPathStore + '/setDataToList', {
          ...payload,
          'where': 'regexp_like (tvtp.TYPE, \'^V(E|X)\')',
          'list_type': 'full'
        })
      }
    }),
    downloadOrders(){
      this.disabled = true;
      let results = this.submitFilter();
      
      results.then((response) => {

        let headerArray = [[
          this.$i18n.t('orderNumber'),
          this.$i18n.t('customer'),
          this.$i18n.t('purchaseOrder'),
          this.$i18n.t('createdDate'),
          this.$i18n.t('requestDate'),
          this.$i18n.t('productCode'),
          this.$i18n.t('product'),
          this.$i18n.t('requestedAmount'),
          this.$i18n.t('pendingAmount'),
          this.$i18n.t('pendingValue'),
          this.$i18n.t('status'),

        ]];
        
        response.data.lista.map(function(data){
          headerArray.push([
            data.SALES_ORDER,
            data.CUSTOMER,
            data.CUSTOMER_PO,
            formatDateValue(data.ORDER_DATE),
            formatDateValue(data.LINE_REQUEST_DATE),
            data.ITEM,
            data.DESCRIPTION,
            data.ORDERED_QUANTITY,
            data.PENDING_QTY,
            currency(data.PRICE),
            data.RELEASED_STATUS,
          ]);  
        });

        let ws_name = 'ItensPendentes'
        let wb = XLSX.utils.book_new()
        let ws = XLSX.utils.aoa_to_sheet(headerArray)
        XLSX.utils.book_append_sheet(wb, ws, ws_name)

        this.wb = wb

        this.downloadFile()
        this.disabled = false;
      });
    },
    downloadFile(){
      let filename = 'ItensPendentes' + '.xlsx'
      XLSX.writeFile(this.wb, filename)
    },
  }
}
</script>